import { render, staticRenderFns } from "./IndexList.vue?vue&type=template&id=d1dadc88&scoped=true&"
import script from "./IndexList.vue?vue&type=script&lang=js&"
export * from "./IndexList.vue?vue&type=script&lang=js&"
import style0 from "./IndexList.vue?vue&type=style&index=0&id=d1dadc88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dadc88",
  null
  
)

export default component.exports